'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = withRouter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    var location = (0, _reactRouterDom.useLocation)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var params = (0, _reactRouterDom.useParams)();
    var contexto = (0, _reactRouterDom.useOutletContext)();
    var router = {
      location: location,
      navigate: navigate,
      params: params,
      push: navigate,
      replace: function replace(to) {
        return navigate(to, { replace: true });
      },
      go: navigate,
      goBack: function goBack() {
        var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        return navigate(pages);
      },
      goForward: function goForward() {
        var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        return navigate(pages);
      }
    };

    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, { router: router }, contexto, { params: params }, params));
  }

  return ComponentWithRouterProp;
}